var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  "+_vm._s(_vm.formatPaymentMethod(_vm.source, _vm.paymentMethod))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }